import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiGet } from '../../api/client';
import type { AdminUser } from '../../types';

const MONTH_NAMES = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

function formatMonth(ym: string) {
  const [y, m] = ym.split('-');
  return `${MONTH_NAMES[parseInt(m, 10) - 1]} ${y}`;
}

export default function AdminMonthUsers() {
  const { month } = useParams<{ month: string }>();
  const [users, setUsers] = useState<AdminUser[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!month) return;
    apiGet<{ users: AdminUser[] }>(`/api/admin/months/${month}/users`)
      .then((d) => setUsers(d.users))
      .catch((e: Error) => setErr(e.message));
  }, [month]);

  if (!month) return null;

  return (
    <div>
      <div className="mb-4">
        <Link to="/yonetim/donemler" className="text-sm text-brand-600 hover:underline">
          ← Dönemlere Dön
        </Link>
      </div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">{formatMonth(month)} İçin Çalışanlar</h1>
      </div>
      {err && <div className="text-red-600 mb-4">{err}</div>}
      {users === null ? (
        <div className="text-slate-500">Yükleniyor…</div>
      ) : users.length === 0 ? (
        <div className="card p-8 text-center text-slate-500">Bu aya ait veri bulunamadı.</div>
      ) : (
        <div className="card overflow-hidden">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-4 py-2">Ad Soyad</th>
                <th className="text-left px-4 py-2">E-posta</th>
                <th className="text-left px-4 py-2">Rol</th>
                <th className="text-right px-4 py-2">Aylık Fiş</th>
                <th className="text-right px-4 py-2">Bekleyen</th>
                <th className="px-4 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-t border-slate-100">
                  <td className="px-4 py-2 font-medium">{u.name}</td>
                  <td className="px-4 py-2">{u.email}</td>
                  <td className="px-4 py-2">
                    <span className={u.role === 'admin' ? 'text-brand-600 font-semibold' : ''}>
                      {u.role === 'admin' ? 'Yönetici' : 'Çalışan'}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-right">{u.receipt_count}</td>
                  <td className="px-4 py-2 text-right">
                    {u.pending_count > 0 ? (
                      <span className="badge-pending">{u.pending_count}</span>
                    ) : (
                      <span className="text-slate-400">0</span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-right">
                    <Link
                      to={`/yonetim/donemler/${month}/kullanicilar/${u.id}`}
                      className="text-brand-600 hover:underline text-sm font-medium"
                    >
                      Fişleri Görüntüle →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
